import * as React from 'react';
import { Image, Grid, Header, Icon, SemanticICONS, Button } from 'semantic-ui-react';

interface Props {
    img?: string;
    icon?: SemanticICONS;
    header: string;
    description: () => JSX.Element;
    more?: () => JSX.Element;
}

interface State {
  expanded?: boolean;
}

export class ExpandableProblemSolutionItem extends React.Component<Props, State> {

    constructor(props: any) {
      super(props);
      this.state = {
      }
    }
  
    toggle = () => this.setState({ expanded: !this.state.expanded })
  
    render() {
      const { img, icon, header, description, more } = this.props
      const { expanded } = this.state
  
      return <Grid.Column style={{ paddingBottom: '5em', paddingTop: '1em' }}>
        { img ? <Image src={img} /> : <Icon name={icon} size="huge" /> }
        <Header as='h3' style={{ fontSize: '2em' }}>{header}</Header>
        <div style={{ fontSize: '1.33em' }}>{description()}</div>
        <div style={{ marginTop: "1em" }}>
          { (expanded || ! more) ? null : <Button onClick={this.toggle}>More</Button> }
          { expanded && more ? <div>{more()}<Button circular icon="arrow up" onClick={this.toggle} /></div> : null }
        </div>
      </Grid.Column>
    }
  }


// WEBPACK FOOTER //
// ./src/home/ExpandableProblemSolutionItem.tsx